const PUP_DISPLAY_NAME = "Gantt View"
const PUP_ID = "9"
const TRELLO_TOKEN_KEY = "gantt-chart-trello-token"
const DASHER_TOKEN = "dasher-token"

/** Where this power-up serves the feedback header action's icon from. */
const FEEDBACK_ICON_PATH = "/feedback-icon.svg"

export { PUP_DISPLAY_NAME, PUP_ID, TRELLO_TOKEN_KEY, DASHER_TOKEN, FEEDBACK_ICON_PATH }
